import styled from "styled-components";

export const Section = styled.div`
  background-color: var(--rose-20);
  box-shadow: 0px 4px 6px var(--shadow-light);
  text-align: center;
  padding: 5% 10%;
  margin: 0 auto;
  max-width: 960px;
  line-height: 1.5em;
  z-index: 2;

  h2 {
    margin-bottom: 40px;
    text-shadow: 2px 2px 4px var(--burgundy-40);
  }
`;

export const LogosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 30px;
  justify-items: center;
  align-items: center;

  @media (max-width: 1080px) {
    padding: 0 100px;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const Logo = styled.img`
  max-width: 100px;
  max-height: 60px;
  object-fit: contain;
  transition: transform 0.2s ease-in-out;
  filter: grayscale(10);

  &:hover {
    transform: scale(1.1);
    filter: none;
  }
`;
